import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.timers";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { validateRuleData, enumData } from '@/decorators';
import SingleUpload from '@/components/singleUpload/index.vue';
import PayAccountAddOrEdit from '@/views/finance/payAccount/components/addOrEdit.vue';
import util from '@/utils/util';
import NoticeModal from './noticeTips.vue';
var noticeModal = util.mountVueComponent(NoticeModal);

var Refund = function (_super) {
  __extends(Refund, _super);

  function Refund() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.summaryList = [];
    _this.payAccountList = [];
    _this.bankList = [];
    _this.rechargeAccountList = [];
    _this.editPayAccountId = '';
    _this.currencyCodeList = [];
    _this.currencyList = [];
    _this.summaryLoading = true;
    _this.formDataRules = {};
    _this.formData = _this.initFormData();
    _this.accountList = [];
    _this.refundTypeEnum = [];
    _this.smallCurrencyCodesEnum = [];
    _this.uploadTipMessage = '';
    _this.previewProof = _this.data ? _this.data.preview_proof : undefined;
    _this.agree = false;
    _this.isErrorTip = false;
    return _this;
  }

  Object.defineProperty(Refund.prototype, "showRefundTypeEnum", {
    get: function get() {
      var _this = this;

      var res = this.accountList.find(function (item) {
        return item.account_code === _this.formData.account_code;
      });

      if (!res) {
        return [];
      }

      return this.refundTypeEnum;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Refund.prototype, "selectedReceiveAccountKeys", {
    get: function get() {
      return this.formData.receive_bank_account ? [this.formData.receive_bank_account] : [];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Refund.prototype, "receiveAccountColumns", {
    get: function get() {
      return [{
        title: this.t('银行名称'),
        dataIndex: 'pay_bank_name',
        width: 180
      }, {
        title: this.t('开户行名称'),
        dataIndex: 'open_bank_name',
        scopedSlots: {
          customRender: 'open_bank_name'
        },
        width: 180
      }, {
        title: this.t('银行账号'),
        dataIndex: 'pay_account',
        scopedSlots: {
          customRender: 'pay_account'
        },
        width: 160
      }, {
        title: this.t('币种'),
        scopedSlots: {
          customRender: 'currency_codes'
        },
        width: 220
      }, {
        title: this.t('操作'),
        scopedSlots: {
          customRender: 'operation'
        },
        width: 80
      }];
    },
    enumerable: false,
    configurable: true
  });

  Refund.prototype.handleSave = function () {
    var _a;

    return __awaiter(this, void 0, Promise, function () {
      var formModelRef, service_regist_country, payAccount, flag, needBsbCode, accountItem, formData, res;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.isErrorTip = !this.agree;
            formModelRef = this.$refs.formModelRef;
            return [4, formModelRef.validate()];

          case 1:
            _b.sent();

            if (!this.agree) {
              this.$message.warning(this.t('请先勾选协议'));
              return [2];
            }

            service_regist_country = (_a = this.accountList.find(function (item) {
              return item.account_code === _this.formData.account_code;
            })) === null || _a === void 0 ? void 0 : _a.service_regist_country;
            payAccount = this.payAccountList.find(function (item) {
              return item.pay_account === _this.formData.receive_bank_account;
            });
            flag = !(payAccount === null || payAccount === void 0 ? void 0 : payAccount.swift_code) && (payAccount === null || payAccount === void 0 ? void 0 : payAccount.isthird_party) === String(this.$enum.common.BoolIntEnum.NO) && ((payAccount === null || payAccount === void 0 ? void 0 : payAccount.open_bank_country_code) !== this.$enum.mine.RegisterAreaCodeEnum.CN || (payAccount === null || payAccount === void 0 ? void 0 : payAccount.open_bank_country_code) === this.$enum.mine.RegisterAreaCodeEnum.CN && (service_regist_country === this.$enum.mine.RegisterAreaCodeEnum.CN && this.formData.currency_code !== 'RMB' || service_regist_country !== this.$enum.mine.RegisterAreaCodeEnum.CN));
            if (!flag) return [3, 3];
            return [4, this.beforeSwiftCode()];

          case 2:
            _b.sent();

            _b.label = 3;

          case 3:
            needBsbCode = (payAccount === null || payAccount === void 0 ? void 0 : payAccount.isthird_party) === String(this.$enum.common.BoolIntEnum.NO) && (payAccount === null || payAccount === void 0 ? void 0 : payAccount.open_bank_country_code) === this.$enum.mine.RegisterAreaCodeEnum.AU && !(payAccount === null || payAccount === void 0 ? void 0 : payAccount.bsb_code);
            if (!needBsbCode) return [3, 5];
            return [4, this.beforeBsbCode()];

          case 4:
            _b.sent();

            _b.label = 5;

          case 5:
            this.formData.accept = this.$enum.common.BoolIntEnum.YES;
            accountItem = this.$util.findItemByKeyValue(this.payAccountList, this.formData.receive_bank_account, 'pay_account');
            this.formData.customer_pay_info_id = accountItem === null || accountItem === void 0 ? void 0 : accountItem.customer_pay_info_id;
            formData = this.$util.deepCopy(this.formData);

            if (formData.refund_type === this.$enum.finance.RefundTypeEnum.DEPOSIT_REFUNDS) {
              formData.bank_currency_code = formData.currency_code;
            }

            return [4, this.$api.finance.editRefundOrder(formData)];

          case 6:
            res = _b.sent();
            this.$message.success(this.t('操作成功'));
            this.$emit('success');
            return [2];
        }
      });
    });
  };

  Refund.prototype.beforeSwiftCode = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, new Promise(function (resove, reject) {
              return __awaiter(_this, void 0, void 0, function () {
                var res;

                var _this = this;

                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4, this.$confirm({
                        title: this.tc('提示'),
                        content: this.t("\u5F00\u6237\u884C\u56FD\u5BB6\u3001\u8C37\u4ED3\u4E3B\u4F53\u975E\u4E2D\u56FD\u5927\u9646\u6216\u7ED3\u7B97\u5E01\u79CD\u975ECNY,\u8BF7\u81F3\u4ED8\u6B3E\u8D26\u6237\u9875\u9762\u8865\u5145Swift Code\uFF01"),
                        okText: this.t('去维护'),
                        cancelText: this.t('取消'),
                        onOk: function onOk() {
                          return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                              this.$router.push({
                                name: 'PayAccountListPage'
                              });
                              reject();
                              return [2];
                            });
                          });
                        },
                        onCancel: function onCancel() {
                          reject();
                        }
                      })];

                    case 1:
                      res = _a.sent();
                      return [2];
                  }
                });
              });
            })];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  Refund.prototype.beforeBsbCode = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, new Promise(function (resove, reject) {
              return __awaiter(_this, void 0, void 0, function () {
                var res;

                var _this = this;

                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4, this.$confirm({
                        title: this.tc('提示'),
                        content: this.t('请补充境内汇款代码后再发起退款。'),
                        okText: this.t('去维护'),
                        cancelText: this.t('取消'),
                        onOk: function onOk() {
                          return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                              this.$router.push({
                                name: 'PayAccountListPage'
                              });
                              reject();
                              return [2];
                            });
                          });
                        },
                        onCancel: function onCancel() {
                          reject();
                        }
                      })];

                    case 1:
                      res = _a.sent();
                      return [2];
                  }
                });
              });
            })];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  Refund.prototype.handleReceiveAccountSelect = function (selectedRowKeys) {
    this.formData.receive_bank_account = selectedRowKeys[0];
    this.handleReceiveBankAccountChange();
  };

  Refund.prototype.handleEditPayAccount = function (record) {
    this.editPayAccountId = record.customer_pay_info_id;
    var editView = this.$refs.payAccountEditRef;
    editView.visible = true;
  };

  Refund.prototype.handlePayAccountEditSuccess = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.formData.account_code) {
              return [2];
            }

            return [4, this.queryAvailableInvoiceList(this.formData.account_code)];

          case 1:
            _a.sent();

            return [4, this.getReceiveBankMessage()];

          case 2:
            _a.sent();

            return [2];
        }
      });
    });
  };

  Refund.prototype.queryBankList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.finance.queryBankList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.bankList = data;
            return [2];
        }
      });
    });
  };

  Refund.prototype.queryRechargeAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.rechargeAccountList = data.map(function (item) {
              return __assign(__assign({}, item), {
                sign_business_list_text: item.sign_business_list.map(function (it) {
                  return it.key;
                }).join(',')
              });
            });
            return [2];
        }
      });
    });
  };

  Refund.prototype.resetFields = function () {
    var formModelRef = this.$refs.formModelRef;
    formModelRef.resetFields();
  };

  Refund.prototype.initData = function () {
    this.formData = this.initFormData();
  };

  Refund.prototype.handleUploadFileTipMessage = function (text) {
    this.uploadTipMessage = text;
  };

  Refund.prototype.handleUploadSuccess = function () {
    var _this = this;

    var timer = setTimeout(function () {
      var formDataRef = _this.$refs.formDataRef;
      formDataRef.validateField('proof', function () {});
      clearTimeout(timer);
    }, 0);
    this.previewProof = '';
  };

  Refund.prototype.getAddRuleData = function (data) {
    this.formDataRules = this.$util.mergeValidate(data, {
      proof: [{
        required: true,
        message: this.t('请上传客户银行回单'),
        trigger: 'change'
      }]
    });
  };

  Refund.prototype.initFormData = function () {
    return {
      order_number: '',
      account_code: this.$route.query.account_code,
      refund_type: undefined,
      receive_account_name: '',
      receive_bank_account: undefined,
      receive_bank_name: '',
      amount: '',
      currency_code: undefined,
      proof: undefined,
      refund_remark: '',
      accept: this.$enum.common.BoolIntEnum.NO,
      customer_pay_info_id: ''
    };
  };

  Refund.prototype.handleAccountCodeChange = function (currAccountCode) {
    if (currAccountCode) {
      this.queryAccountSummary(currAccountCode);
      this.formData.receive_bank_account = undefined;
      this.formData.refund_type = undefined;
      this.formData.receive_account_name = '';
      this.formData.receive_bank_name = '';
      this.formData.currency_code = undefined;
      this.queryAvailableInvoiceList(currAccountCode);
    }
  };

  Refund.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryNoTariffAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data.map(function (item) {
              return __assign(__assign({}, item), {
                sign_business_list_text: item.sign_business_list.map(function (it) {
                  return it.key;
                }).join(',')
              });
            });
            return [2];
        }
      });
    });
  };

  Refund.prototype.queryAccountSummary = function (currAccountCode) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.summaryLoading = true;
            return [4, this.$api.finance.queryAccountSummary({
              account_code: currAccountCode
            })];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.summaryLoading = false;
            this.summaryList = data;
            return [2, data];
        }
      });
    });
  };

  Refund.prototype.queryAvailableInvoiceList = function (currAccountCode) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryAvailablePayAccountList({
              account_code: currAccountCode,
              is_filter_third_party: true
            })];

          case 1:
            data = _a.sent().data;
            this.payAccountList = data;
            return [2];
        }
      });
    });
  };

  Refund.prototype.handleReceiveBankAccountChange = function () {
    return __awaiter(this, void 0, Promise, function () {
      var currencyCode, currency;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.getReceiveBankMessage()];

          case 1:
            _a.sent();

            currencyCode = this.$route.query.recharge_currency;
            currency = this.currencyCodeList.find(function (item) {
              return item.currency_code === currencyCode;
            });

            if (currency) {
              this.formData.currency_code = this.$route.query.recharge_currency;
            }

            return [2];
        }
      });
    });
  };

  Refund.prototype.getReceiveBankMessage = function () {
    return __awaiter(this, void 0, void 0, function () {
      var payAccount;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            payAccount = this.$util.findItemByKeyValue(this.payAccountList, this.formData.receive_bank_account, 'pay_account');
            if (!payAccount) return [3, 2];
            this.formData.receive_account_name = payAccount.pay_account_name;
            this.formData.receive_bank_name = payAccount.pay_bank_name;
            return [4, this.queryCurrencyCodeList({
              customer_pay_info_id: payAccount.customer_pay_info_id
            })];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  Refund.prototype.queryCurrencyCodeList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCurrencyCodeList(params)];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.currencyCodeList = data;
            return [2];
        }
      });
    });
  };

  Refund.prototype.queryCurrencyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCurrencyList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.currencyList = data;
            return [2];
        }
      });
    });
  };

  Refund.prototype.created = function () {
    return __awaiter(this, void 0, Promise, function () {
      var account_code;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.type === this.$enum.common.ModalTypeEnum.EDIT) {
              Object.keys(this.formData).forEach(function (key) {
                _this.formData[key] = _this.data[key];
              });
            } else {
              account_code = this.$route.query.account_code;
              this.formData.account_code = account_code;
            }

            this.queryAccountSummary(this.formData.account_code);
            this.queryAvailableInvoiceList(this.formData.account_code);
            this.queryCurrencyList();
            this.queryBankList();
            this.queryRechargeAccountList();
            return [4, this.queryAccountList()];

          case 1:
            _a.sent();

            this.getReceiveBankMessage();
            return [2];
        }
      });
    });
  };

  Refund.prototype.handleNotice = function () {
    noticeModal({
      parent: this
    });
  };

  Refund.prototype.isSmallCurrency = function (code) {
    var _a;

    return (_a = this.smallCurrencyCodesEnum) === null || _a === void 0 ? void 0 : _a.some(function (item) {
      return item.value === code;
    });
  };

  Refund.prototype.handleCurrencyChange = function () {
    var _this = this;

    setTimeout(function () {
      var refAmount = _this.$refs.refAmount;
      refAmount === null || refAmount === void 0 ? void 0 : refAmount.focus();
      refAmount === null || refAmount === void 0 ? void 0 : refAmount.blur();
    }, 0);
  };

  __decorate([Prop({
    type: String,
    "default": undefined
  })], Refund.prototype, "type", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], Refund.prototype, "data", void 0);

  __decorate([enumData('Finance/RefundTypeEnum')], Refund.prototype, "refundTypeEnum", void 0);

  __decorate([enumData('Finance/SmallCurrency/SmallCurrencyCodesEnum')], Refund.prototype, "smallCurrencyCodesEnum", void 0);

  __decorate([validateRuleData('/api/v1/finance/balance_return/edit_refund_order')], Refund.prototype, "getAddRuleData", null);

  Refund = __decorate([Component({
    components: {
      SingleUpload: SingleUpload,
      PayAccountAddOrEdit: PayAccountAddOrEdit
    }
  })], Refund);
  return Refund;
}(Vue);

export default Refund;